const DolfinIcon = ({
  color = 'text-primary',
  size = 32,
  variant = 'light'
}: {
  color?: string
  size?: number
  variant?: 'light' | 'dark'
}) => {
  return (
    <svg
      className={color}
      width={size}
      height={size}
      viewBox='0 0 140 140'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        width='140'
        height='140'
        rx='40'
        fill={variant === 'dark' ? '#013752' : '#DAFF87'}
      />
      <path
        d='M68.3553 102.476C75.9433 102.476 82.8958 100.52 88.5591 95.5469C91.5197 92.9445 93.7114 89.769 95.1986 86.1174C98.1822 78.7911 98.6242 69.5465 97.2705 61.8181C95.4748 51.5011 89.3925 42.8852 79.2906 39.4832C75.6256 38.2491 71.873 37.5441 67.9732 37.5394H51.6464C48.8232 37.5394 46 37.5394 46 43.1859C46 64.3836 51.1759 67.6538 61.2924 70.0064C51.1759 72.3591 46 75.6529 46 96.827C46 102.473 48.8232 102.485 51.6464 102.485L68.3507 102.476H68.3553Z'
        fill={variant === 'dark' ? '#DAFF87' : '#013752'}
      />
    </svg>
  )
}

export default DolfinIcon
